let storedSuburbId = localStorage.getItem("agSitePostStateId");

storedSuburbId = storedSuburbId ? storedSuburbId : 1;

const checkboxSvg = document.getElementById("checkboxSvg");
const plusSvg = document.getElementById("plusSvg");
const minusSvg = document.getElementById("minusSvg");

const shippingDetailsDivIdName = "shippingDetails";
const shippingNotAvailableDivIdName = "shippingNotAvailable";


const localStoragePostcodePostal = "agSitePostcode";
const localStorageSuburbPostal = "agSitePostSuburb";




/**
* Get all shipping time, shipping price, shipping type, product type, text, and location data
* for this particular suburb
* 
* @param int suburbId - Database primary key id of the suburb 
* @returns {*} with data from strapi
*/
async function loadShippingTimes(suburbId, shopifyProductId, stock, stockBuffer, productType, stockArrivalDate){
    // console.log("Loading shipping times!!!");

    //Old fetch function that doesnt take env into account
    // const res = await fetch(`https://api.agstark.com/api/ship-time-price/get-calculated-by-product?suburbId=${suburbId}&shopifyProductId=${shopifyProductId}&stock=${stock}&stockBuffer=${stockBuffer}&productType=${productType}&stockArrivalDate=${stockArrivalDate}`);
    //const data = await res.json();

    // const postcode = localStorage.getItem(localStoragePostcodePostal);
    // const suburb = localStorage.getItem(localStorageSuburbPostal);

    let counter = 0;
    const waitLimit = 1000;

    while(sessionStorage.getItem("timesRetrieved") === "false"){
        // console.log("Waiting for shipping slots to be retrieved");
        await new Promise(resolve => setTimeout(resolve, 100));
        counter++;
        if(counter > waitLimit){
            break;
        }
    }

    const slotsPass = sessionStorage.getItem("shippingSlots");


    //New fetch function which changes base domain based on env status
    const data = await AG.fetch(`/api/ship-time-price/get-calculated-by-product?suburbId=${suburbId}&shopifyProductId=${shopifyProductId}&stock=${stock}&stockBuffer=${stockBuffer}&productType=${productType}&stockArrivalDate=${stockArrivalDate}&planningDatesA=${slotsPass}`, {
        method: 'GET',
    });

    return data.data;
}




/**
* Shipping info divs display individual lines
* of shipping info for each shipping type. These
* lines are shown to the customer on the page.
* 
* @param arr shippingInfo - array of objects {msg: str, tooltip: str}  
* 
* @returns {*} - dom object containing all elements to be displayed
*/
function setShippingInfoDiv(shippingInfo){

    

    const parentDiv = document.createElement("div");
    parentDiv.classList.add("additional_info");



    shippingInfo.forEach((element)=>{

        
        const detailsDiv = document.createElement("details");
        detailsDiv.classList.add("facets__disclosure-vertical", "js-filter");
        detailsDiv.innerText = "TEST";
        parentDiv.appendChild(detailsDiv);

    });


    

    return parentDiv;
}

async function resetShippingSlots(){
    // console.log("resetting shipping slots")
    sessionStorage.setItem("timesRetrieved", "false");

    // const postcodeGet = localStorage.getItem("agSitePostcode");
    // const suburbGet = localStorage.getItem("agSitePostSuburb");

    // console.log("Postcode: " + postcodeGet);
    // console.log("Suburb: " + suburbGet);


    let aShippingDateSlotsGet = [];
   

    sessionStorage.setItem("timesRetrieved", "true");

    sessionStorage.setItem("shippingSlots", JSON.stringify(aShippingDateSlotsGet));

          

}

/**
* shows the ship prices on the page
* 
* @param int suburbId - Database primary key id of the suburb
* @param {*} productTypeCode 
* @param {*} shippingDetailsDiv - the final div to which the data in the function will be added
*/
async function showShipPrices(suburbId, productTypeCode, shippingDetailsDiv, shopifyProductId, stock, stockBuffer, productType, stockArrivalDate, reset){
    //First set the Div which shows the location and provides the shipping selector
    // setDeliveringToLocation();

    if(reset){
        await resetShippingSlots();
    }


    //Subsequent divs show the shipping delivery data
    shippingDetailsDiv.innerHTML = "";

    //get shipping data from Strapi
    const shippingData = await loadShippingTimes(suburbId, shopifyProductId, stock, stockBuffer, productType, stockArrivalDate);


    const shippingNotAvailableDiv = document.getElementById(shippingNotAvailableDivIdName);
    shippingNotAvailableDiv.style.display = 'none';
    
    
    //Used to track only relevant iterations to show shipping info. key is no good to us here. 
    let iteration = 0;
    
    //For each of the shipping types, display and calculate shipping days

    let infoSet = false; //we only want to use the first relevant entry for this field. When true stop parsing for this field.

    for(let i = 0; i < shippingData.length; i++){

        //First show in the info field
        const infoSection = document.getElementById("comguysShippingInfo");

        //Next show in the collapsible shipping type items
        const value = shippingData[i];

        const shippingInfo = value.shipping_info;
        const additionalinfoDiv = document.createElement("div");
        additionalinfoDiv.classList.add("additional_info");


        //Get the shippng type title and price first
        const shippingTypeName = value.shipping_type_name;
        const shippingPrice = value.priceText;

        

        if(value.productTypeCode == productTypeCode){
            
            //Only add to the info upper info section if the span section exists
            if(infoSection && !infoSet){
                infoSection.innerHTML = `This one flew off the shelves... but you haven't missed out, it's coming back!  You will be able to select a delivery date at checkout. We will notify you if there are any delays. The current ETA for delivery is ${value.by_or_between} ${value.opinionatedDateText}`;

                infoSet = true;
            }

            //main wrapper div for all shipping

            const detailsDiv = document.createElement("details");
            detailsDiv.classList.add("facets__disclosure-vertical", "js-filter");

            detailsDiv.setAttribute('open', '');

            //Contains shipping name and price
            const summaryDiv = document.createElement("summary");
            summaryDiv.classList.add("facets__summary", "caption-large", "focus-offset");
            summaryDiv.setAttribute('aria-label', `${shippingTypeName}: ${shippingPrice}`);
            summaryDiv.innerHTML = `<span>${shippingTypeName}: <span class="color">${shippingPrice}</span></span>`;
            const plusClone = plusSvg.cloneNode(true); 
            const minusClone = minusSvg.cloneNode(true);

            plusClone.removeAttribute("class");
            minusClone.removeAttribute("class");

            summaryDiv.appendChild(plusClone);
            summaryDiv.appendChild(minusClone);


            //Wrapper div for individual shipping messaging
            const borderDiv = document.createElement("div");
            borderDiv.classList.add("border-main");

            //Set the next delivery date
            const opinionatedDateText = value.opinionatedDateText;

            //by or between
            const byOrBetween = value.by_or_between;

            

            //Add first element 
            const additionalInfoDisplayDiv_b = document.createElement("div"); //div to send
            additionalInfoDisplayDiv_b.classList.add("additional_info_display");
            const checkDiv_b = document.createElement("div");
            checkDiv_b.classList.add("check", "cstm-show-icon", "tickNudge");

            const checkIcon_b = checkboxSvg.cloneNode(true); 
            checkIcon_b.classList.add("tickNudge");
            checkIcon_b.removeAttribute("class");
            checkDiv_b.appendChild(checkIcon_b);

            additionalInfoDisplayDiv_b.appendChild(checkDiv_b);

                const contentDiv_b = document.createElement("div"); //div to send
                contentDiv_b.classList.add("content");
                contentDiv_b.innerHTML = `<span>Order now for delivery ${byOrBetween} <span class="color-text">${opinionatedDateText}</span></span>`;

                additionalInfoDisplayDiv_b.appendChild(contentDiv_b);


            borderDiv.appendChild(additionalInfoDisplayDiv_b);


            // shippingInfo.forEach((element)=>{
            for(let p = 0; p < shippingInfo.length; p++){

                const element = shippingInfo[p];
                
                const additionalInfoDisplayDiv = document.createElement("div"); //div to send
                additionalInfoDisplayDiv.classList.add("additional_info_display");

                    const checkDiv = document.createElement("div");
                    checkDiv.classList.add("check", "cstm-show-icon", "tickNudge");

                    const checkIcon = checkboxSvg.cloneNode(true);
                    checkIcon.classList.add("tickNudge");

                    checkIcon.removeAttribute("class");
                    checkDiv.appendChild(checkIcon);

                additionalInfoDisplayDiv.appendChild(checkDiv);

                    const contentDiv = document.createElement("div"); //div to send
                    contentDiv.classList.add("content");
                    contentDiv.innerHTML = `<span>${element.msg}</span>`;

                additionalInfoDisplayDiv.appendChild(contentDiv);



                borderDiv.appendChild(additionalInfoDisplayDiv);
                

            }
            // });

            

            detailsDiv.appendChild(summaryDiv);
            detailsDiv.appendChild(borderDiv);
            additionalinfoDiv.appendChild(detailsDiv);
            shippingDetailsDiv.appendChild(additionalinfoDiv);




            iteration++;
        }

    // });
    }

    //If there are no viable shipping options, then iteration is 0, and so we show the customer that we don't ship here.
    try{

        if(localStorage.getItem(localStoragePostcodePostal) && localStorage.getItem(localStorageSuburbPostal)){
            if(iteration === 0){
                shippingNotAvailableDiv.style.display = "block";
            } else {
                shippingNotAvailableDiv.style.display = "none";
            }
        }
    } catch(err){
        return;
    }


}



const productType = document.getElementById("productType"); //Contains product data
const shippingDetails = document.getElementById(shippingDetailsDivIdName); //displays the shipping data
const typeCode = productType.getAttribute("data-type");

let shipDatesList = [];

showShipPrices(storedSuburbId, typeCode, shippingDetails, shopifyProductIdGet, productVariantAvailableStock, productSkuSohBuffer, productGetProductType, productStockArrivalDate, false);

const suburbListListen = document.getElementById("suburbList");
//Get postcode data from api and show in overlay

suburbListListen.addEventListener("click", async ()=>{
    const updatedSuburbId = localStorage.getItem("agSitePostStateId");
    const updatedtypeCode = productType.getAttribute("data-type");
    const updatedshippingDetails = document.getElementById(shippingDetailsDivIdName); //displays the shipping data
    showShipPrices(updatedSuburbId, updatedtypeCode, updatedshippingDetails, shopifyProductIdGet, productVariantAvailableStock, productSkuSohBuffer, productGetProductType, productStockArrivalDate, true);
});


const suburbListBottomListen = document.getElementById("suburbListBottom");
//Get postcode data from api and show in overlay

suburbListBottomListen.addEventListener("click", async ()=>{
    const updatedSuburbId = localStorage.getItem("agSitePostStateId");
    const updatedtypeCode = productType.getAttribute("data-type");
    const updatedshippingDetails = document.getElementById(shippingDetailsDivIdName); //displays the shipping data
    showShipPrices(updatedSuburbId, updatedtypeCode, updatedshippingDetails, shopifyProductIdGet, productVariantAvailableStock, productSkuSohBuffer, productGetProductType, productStockArrivalDate, true);
});


//headShipParentDiv